// extracted by mini-css-extract-plugin
export default {"header":"ingredients-group_header__bXIw-","body":"ingredients-group_body__OrGcO"};